(function($) {

$(document).ready(function(){
	$('.header__language').on('mouseenter',function(){
		$(this).find('.header__language__list').stop().slideDown('fast');
	});
	$('.header__language').on('mouseleave',function(){
		$(this).find('.header__language__list').stop().slideUp('fast');
	});	
});

})( jQuery );  